import createIcon from '../../createIcon';

/**
 * @component @name ElderlyWoman
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxMUMxNS45NCAxMSAxNC41OCAxMC4xIDEzLjkyIDguNzlMMTMuMTMgNy4xMkMxMy4xMiA3LjEgMTIuNjMgNiAxMS4zNCA2QzcuNzIgNiA1IDE2LjY5IDUgMTlINy41TDUuNCAyMS44TDcgMjNMMTAgMTlIMTJWMjNIMTRWMTguOTdMMTIgMTNMMTIuNDkgMTAuMjlDMTMuMyAxMS41MiAxNC41NCAxMi40MyAxNiAxMi44MVYxMy41SDE3VjEyLjVDMTcgMTIuMjIgMTcuMjIgMTIgMTcuNSAxMkMxNy43OCAxMiAxOCAxMi4yMiAxOCAxMi41VjIzSDE5VjEyLjVDMTkgMTEuNjcgMTguMzMgMTEgMTcuNSAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC42IDIuOTFDMTAuNTQgMy4xIDEwLjUgMy4yOSAxMC41IDMuNUMxMC41IDQuNiAxMS40IDUuNSAxMi41IDUuNUMxMy42IDUuNSAxNC41IDQuNiAxNC41IDMuNUMxNC41IDIuNCAxMy42IDEuNSAxMi41IDEuNUMxMi4yOSAxLjUgMTIuMSAxLjU0IDExLjkxIDEuNkMxMS43NiAxLjI1IDExLjQxIDEgMTEgMUMxMC40NSAxIDEwIDEuNDUgMTAgMkMxMCAyLjQxIDEwLjI1IDIuNzYgMTAuNiAyLjkxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElderlyWoman = createIcon('ElderlyWoman', [
  [
    'path',
    {
      d: 'M17.5 11C15.94 11 14.58 10.1 13.92 8.79L13.13 7.12C13.12 7.1 12.63 6 11.34 6C7.72 6 5 16.69 5 19H7.5L5.4 21.8L7 23L10 19H12V23H14V18.97L12 13L12.49 10.29C13.3 11.52 14.54 12.43 16 12.81V13.5H17V12.5C17 12.22 17.22 12 17.5 12C17.78 12 18 12.22 18 12.5V23H19V12.5C19 11.67 18.33 11 17.5 11Z',
      key: 'u6jqzk',
    },
  ],
  [
    'path',
    {
      d: 'M10.6 2.91C10.54 3.1 10.5 3.29 10.5 3.5C10.5 4.6 11.4 5.5 12.5 5.5C13.6 5.5 14.5 4.6 14.5 3.5C14.5 2.4 13.6 1.5 12.5 1.5C12.29 1.5 12.1 1.54 11.91 1.6C11.76 1.25 11.41 1 11 1C10.45 1 10 1.45 10 2C10 2.41 10.25 2.76 10.6 2.91Z',
      key: '88rtwc',
    },
  ],
]);

export default ElderlyWoman;
